import { trpc } from './trpc';

type OperatoorStatus = {
  healthz: string;
};

export const getOperatoorStatus = async (): Promise<OperatoorStatus> => {
  // @ts-ignore
  const url = import.meta.env.VITE_OPERATOOR_URL!;

  const response = await fetch(`${url}/healthz`);
  if (!response.ok) {
    throw new Error(`Operatoor status error! Status: ${response.status}`);
  }

  return await response.json();
};

export const getJigsawStatus = async () => {
  try {
    return await trpc.getHealthz.query();
  } catch (e) {
    throw new Error(`Jigsaw status error! Status: ${(e as Error).message}`);
  }
};

export const getBackendStatuses = async () => {
  try {
    const [operatoorStatus, jigsawStatus] = await Promise.all([
      getOperatoorStatus(),
      getJigsawStatus(),
    ]);
    return { operatoorStatus, jigsawStatus };
  } catch (error) {
    throw new Error(
      `Failed to fetch backend statuses: ${(error as Error).message}`
    );
  }
};
